import React, { Component } from 'react';
import './App.css';
import Videos from './videos.js';

class App extends Component {

  constructor(props) {
    super(props)
    window.App = this
    this.state = { index: 0 }
    var agent = window.navigator.userAgent

    if (agent.match(/iPhone/) || agent.match(/iPad/)) {
      alert('Hi - on iOS, ' + 
        'you have to tap each video to start it ' + 
        '(they don\'t play automatically).')
    }
  }

  getVideoList() {
    var links = Videos.map((video, i) => {
      var isSelected = i === this.state.index
      var key = `${video.id}-${video.startSeconds}`
      var startSeconds = video.startSeconds || 0
      var endSeconds = video.endSeconds || (startSeconds + 5)
      var duration = endSeconds - startSeconds
      
      return (
        <li key={key} className={isSelected && 'selected'}>
          <a id={video.id} href={`#${video.id}`}
            onClick={() => this.setState({ index: i }, this.play.bind(this))}>
            {i+1}. {video.title}
            <span className="metadata">
              <span className="duration">({duration}s)</span>
              <span>&middot;</span>
              <span className="user">{video.user||'adamloving'}</span>
            </span>
          </a>
        </li>)
    })

    return (<ul>{links}</ul>)
  }

  createPlayer() {
    console.log('createPlayer')
    this.player = new window.YT.Player('player', {
      playerVars: { controls: 0, rel: 0, playsinline: 1 },
      events: {
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this),
        'onError': (event) => console.error(event.data)
      }
    });
  }

  onPlayerReady() {
    // console.log('onPlayerReady')
    this.play()
  }

  play() {
    var video = Videos[this.state.index]
    // console.log('play', this.state.index, video)

    var startSeconds = video.startSeconds || 0
    var endSeconds = video.endSeconds || (startSeconds + 15)

    this.player.loadVideoById({
      videoId: video.id,
      startSeconds: startSeconds,
      endSeconds: endSeconds
    })
  }

  onPlayerStateChange(event) {
    var playerStateNames = {}
    playerStateNames[-1] = 'unstarted'
    playerStateNames[window.YT.PlayerState.ENDED] = 'ended'
    playerStateNames[window.YT.PlayerState.PLAYING] = 'playing'
    playerStateNames[window.YT.PlayerState.PAUSED] = 'paused'
    playerStateNames[window.YT.PlayerState.BUFFERING] = 'buffering'
    playerStateNames[window.YT.PlayerState.CUED] = 'cued'
    // console.log('onPlayerStateChange', event.data, playerStateNames[event.data])

    if (event.data === window.YT.PlayerState.ENDED) {
      if (this.isSkip) {
        this.isSkip = false
      } else {
        this.nextVideo()
        this.isSkip = true
      }
    }
  }

  nextVideo() {
    this.player.stopVideo()
    this.setState({ index: this.state.index + 1 }, this.play.bind(this))
  }

  componentDidUpdate() {
    var videoId = Videos[this.state.index].id
    var el = document.getElementById(videoId)
    var container = document.getElementsByClassName('list-container')[0]
    container.scrollTop = el.offsetTop - container.offsetTop - 5
    console.log('scroll', el.offsetTop, container.scrollTop)
  }

  render() {
    console.log('render')
    return (
      <div className="app">
        <div id="player"/>
        <div className="list-container">
          {this.getVideoList()}
        </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/